import { render, staticRenderFns } from "./SelectedNewsTable.vue?vue&type=template&id=7ddf82fa&scoped=true&"
import script from "./SelectedNewsTable.vue?vue&type=script&lang=js&"
export * from "./SelectedNewsTable.vue?vue&type=script&lang=js&"
import style0 from "./SelectedNewsTable.vue?vue&type=style&index=0&id=7ddf82fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddf82fa",
  null
  
)

export default component.exports